package com.essntl.features.proposal.ui.proposalhistory.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import core.dateformat.utils.formatTimestampToHHMM
import com.essntl.core.utils.utils.formatIntMoney
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import core.config.CurrencyConfig

@Composable
fun ProposalJourneyDayService(
    service: ServiceModel,
    proposalService: JourneyRowUiState,
    modifier: Modifier = Modifier,
) {
    Row(
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier = modifier
            .background(
                color = MaterialTheme.esColorScheme.bgSecondary,
                shape = RoundedCornerShape(16.dp),
            )
            .padding(
                vertical = 1.spacing,
                horizontal = 2.spacing,
            ),
    ) {
        Column(
            verticalArrangement = Arrangement.spacedBy(.5f.spacing),
            modifier = Modifier.weight(1f),
        ) {
            Text(
                text = service.title,
                color = MaterialTheme.esColorScheme.textPrimary,
                style = MaterialTheme.esTypography.p1Medium16,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )

            Text(
                text = service.headline ?: "",
                color = MaterialTheme.esColorScheme.textSecondary,
                style = MaterialTheme.esTypography.p2Regular14,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )
        }

        Box(
            modifier = Modifier.alignByBaseline(),
        ) {
            Column(
                verticalArrangement = Arrangement.spacedBy(.5f.spacing),
            ) {
                proposalService.startTime?.let {
                    Text(
                        text = formatTimestampToHHMM(it),
                        color = MaterialTheme.esColorScheme.textPrimary,
                        style = MaterialTheme.esTypography.p1Medium16,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                    )
                }

                if (!proposalService.isItinerary)
                    proposalService.price?.let {
                        val currency = proposalService.priceCurrencySymbol ?: CurrencyConfig.defaultCurrencySymbol
                        
                        Text(
                            text = "$currency${formatIntMoney(it)}",
                            color = MaterialTheme.esColorScheme.textPrimary,
                            style = MaterialTheme.esTypography.p1Medium16,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis,
                        )
                    }
            }
        }
    }
}